import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { Modal, Button } from "@mui/material";
import { toast } from "react-toastify";
import { addStaff } from "../api/Users";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../api/constant";
import { MDBTypography } from "mdb-react-ui-kit";
import { Image } from "react-bootstrap";
import multi_img from "../images/multiple_docs.png";

const AddStaff = ({ userData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const {
    formState: { errors },
  } = useForm();
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const rowData = location.state;

  const [staff, setStaff] = useState({
    name: "",
    father_name: "",
    post: "",
    date_of_birth: "",
    category: "",
    gender: "",
    doj: "",
    HRMS_id: "",
    phone_number: "",
    category_of_school: "",
    ddo: "",
    staff_aadhaar: "",
    staff_pan: "",
    highest_qualification: "",
    tenth_qualification: "",
    twelveth_qualification: "",
  });

  const [error, setErrors] = useState({});

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const [photo, setPhoto] = useState(null);
  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.error("No student photo selected!.");
      return;
    }
    const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i; // Allowed file types

    if (!allowedExtensions.test(file.name)) {
      toast.error("Invalid file type. Only JPG and PNG files are allowed.");
      event.target.value = "";
      return;
    }
    setPhoto(file);
  };
  const handleChangeInput = (e) => {
    const { name, value, type, files } = e.target;
  
    if (type !== "file") {
      setStaff((staff) => ({ ...staff, [name]: value }));
    } else {
      const file = files[0];
      setStaff((staff) => ({ ...staff, [name]: file }));
    }
  };
  
  useEffect(() => {
    if (rowData) {
      setStaff((prevStaff) => ({
        ...prevStaff,
        ...rowData,
      }));
    }
  }, [rowData]);

  const navigate = useNavigate(); // Initialize navigate function

  const onSubmit = (e) => {
    e.preventDefault();
    const formErrors = {};
    const namePattern = /^[a-zA-Z\s'-]+$/;

    if (photo == null) {
      formErrors.photo_file = "No Staff photo selected!";
    }

    if (!staff.name.trim()) {
      formErrors.name = "Staff Name is required";
    } else if (!namePattern.test(staff.name)) {
      formErrors.name = " Staff name must contain only letters";
    }

    if (!staff.father_name.trim()) {
      formErrors.father_name = "Father's Name is required";
    } else if (!namePattern.test(staff.father_name)) {
      formErrors.father_name = "Father's Name must contain only letters";
    }

    if (!staff.post.trim()) {
      formErrors.post = "Post is required";
    } else if (!namePattern.test(staff.post)) {
      formErrors.post = "Post must contain only letters";
    }

    if (!staff.gender) {
      formErrors.gender = "Gender is required";
    }

    if (!staff.date_of_birth) {
      formErrors.date_of_birth = "Date of Birth is required";
    }

    if (!staff.category) {
      formErrors.category = "Category is required";
    }

    if (!staff.doj) {
      formErrors.doj = "Date Of Joining is required";
    }

    if (!staff.HRMS_id) {
      formErrors.HRMS_id = "HRMS ID is required";
    }

    if (!staff.phone_number) {
      formErrors.phone_number = "Phone Number is required";
    }

    if (!staff.ddo) {
      formErrors.ddo = "DDO is required";
    }

    if (!staff.category_of_school) {
      formErrors.category_of_school = "Category Of Schhol is required";
    }

    if (
      staff.staff_aadhaar == null ||
      staff.staff_pan == null ||
      staff.student_aadhaar == null ||
      staff.tenth_qualification == null ||
      staff.twelveth_qualification == null
    ) {
      toast.error("Documents upload pending!");
    }

    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
      setIsLoading(true);

      const formData = new FormData();

      formData.append("school_id", userData.data.school_id);
      formData.append("district_code", userData.data.district_code);
      formData.append("teacher_name", staff.name);
      formData.append("post", staff.post);
      formData.append("date_of_birth", staff.date_of_birth);
      formData.append("category", staff.category);
      formData.append("gender", staff.gender);
      formData.append("father_name", staff.father_name);
      formData.append("joining_date", staff.doj);
      formData.append("DDO_name", staff.ddo);
      formData.append("category_of_school", staff.category_of_school);
      formData.append("teacher_contact_no", staff.phone_number);
      formData.append("hrms_id", staff.HRMS_id);
      formData.append("teacher_aadhar_card", staff.staff_aadhaar);
      formData.append("teacher_qualification", staff.highest_qualification);
      formData.append("teacher_pan_card", staff.staff_pan);
      formData.append("teacher_photo", photo);
      formData.append("teacher_tenth_qualification", staff.tenth_qualification);
      formData.append(
        "teacher_twelveth_qualification",
        staff.twelveth_qualification
      );

      addStaff(formData)
        .then((res) => {
          if (res.status === "success") {
            setIsLoading(false);
            toast.success(t(res.message));
            window.location.reload();
          } else {
            toast.error(t(res.message));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleUpdateClick = (row) => {
    setModalOpen(true);
  };

  const back = () => {
    navigate(`/staffdetails`);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <div className="my-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Add Staff Details")}</h5>

          {photo ? (
            <Image
              src={URL.createObjectURL(photo)}
              alt="Uploaded Photo"
              width={100}
              height={100}
              className="mr-4"
            />
          ) : (
            <AccountCircleIcon
              style={{
                width: 100,
                height: 100,
                marginRight: 4,
                background: "#fff",
                color: "whitesmoke",
              }}
            />
          )}
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row">
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Staff Photo")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="file"
                name="photo_file"
                accept="image/*"
                className="form-control"
                onChange={handlePhotoChange}
              />
              {error.photo_file && (
                <div className="text-danger">{error.photo_file}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Staff Name")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="name"
                className="form-control"
                onChange={handleChangeInput}
                required
              />
              {error.name && <div className="text-danger">{error.name}</div>}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Father Name")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="father_name"
                className="form-control"
                onChange={handleChangeInput}
                required
              />
              {error.father_name && (
                <div className="text-danger">{error.father_name}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Post")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="post"
                className="form-control"
                onChange={handleChangeInput}
                required
              />
              {error.post && <div className="text-danger">{error.post}</div>}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Date of Birth")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="date"
                name="date_of_birth"
                className="form-control"
                onChange={handleChangeInput}
                required
              />
              {error.date_of_birth && (
                <div className="text-danger">{error.date_of_birth}</div>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Category")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="category"
                className="form-control"
                onChange={handleChangeInput}
                required
              />
              {error.category && (
                <div className="text-danger">{error.category}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Gender")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="gender"
                onChange={handleChangeInput}
                className="common-input form-select"
                required
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
              {error.gender && (
                <div className="text-danger">{error.gender}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">Date Of Joining</label>
              <input
                type="date"
                className="form-control"
                name="doj"
                onChange={handleChangeInput}
                required
              ></input>
              {error.doj && <div className="text-danger">{error.doj}</div>}
            </div>

            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("HRMS ID")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="input"
                name="HRMS_id"
                className="form-control"
                onChange={handleChangeInput}
                required
              />
              {error.HRMS_id && (
                <div className="text-danger">{error.HRMS_id}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Phone Number")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                onChange={handleChangeInput}
                type="text"
                pattern="[0-9]*"
                maxLength={10}
                minLength={10}
                name="phone_number"
                className="form-control"
                required
              />
              {error.phone_number && (
                <div className="text-danger">{error.phone_number}</div>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Category Of School")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="category_of_school"
                className="form-control"
                onChange={handleChangeInput}
                required
              />
              {error.category_of_school && (
                <div className="text-danger">{error.category_of_school}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Name Of DDO")}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="ddo"
                className="form-control"
                onChange={handleChangeInput}
                required
              />
              {error.ddo && <div className="text-danger">{error.ddo}</div>}
            </div>
            <div className="col-md-4">
              <label className="form-label mt-3">
                {t("Add Documents (PDF only)")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <div className="">
                <button
                  type="button"
                  className="btn btn-secondary col-md-8"
                  onClick={handleUpdateClick}
                >
                  {t("Add")}
                </button>
              </div>
            </div>
            <div className="row col-12 d-flex justify-content-end">
              <button type="submit" className="btn btn-primary me-2 col-md-2">
                {t("Save")}
              </button>
              <button
                type="submit"
                className="btn btn-secondary me-2 col-md-2"
                onClick={back}
              >
                {t("Back")}
              </button>
            </div>

            <Modal
              open={modalOpen}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 1000,
                  backgroundColor: "#ffffff",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: 8,
                  padding: 20,
                }}
              >
                {" "}
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleCloseModal}
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    background: "none",
                    border: "none",
                    fontSize: 24,
                    cursor: "pointer",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </button>
                <div className="row mt-4 mb-2">
                  <div className="row">
                    <div className="col-6 d-flex justify-content-center">
                      <Image src={multi_img} height="300px" />
                    </div>
                    <div className="col-6">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <MDBTypography tag="h5" className="mb-4">
                            {t("Add Documents (PDF only)")}
                          </MDBTypography>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <label className="form-label my-3">
                            {t("Staff Aadhaar")}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="file"
                            name="staff_aadhaar"
                            accept=".pdf"
                            className="form-control"
                            onChange={handleChangeInput}
                          />
                          {staff.staff_aadhaar && (
                            <p className="text-primary">
                              Selected file: {staff.staff_aadhaar.name}
                            </p>
                          )}
                        </div>
                        <div className="col-md-6">
                          <label className="form-label my-3">
                            {t("Staff Pan Card")}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="file"
                            name="staff_pan"
                            accept=".pdf"
                            className="form-control"
                            onChange={handleChangeInput}
                          />
                          {staff.staff_pan && (
                            <p className="text-primary">
                              Selected file: {staff.staff_pan.name}
                            </p>
                          )}
                        </div>
                        <div className="col-md-6">
                          <label className="form-label my-3">
                            {t("10th Certificate")}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="file"
                            name="tenth_qualification"
                            accept=".pdf"
                            className="form-control"
                            onChange={handleChangeInput}
                          />
                          {staff.tenth_qualification && (
                            <p className="text-primary">
                              Selected file: {staff.tenth_qualification.name}
                            </p>
                          )}
                        </div>
                        <div className="col-md-6">
                          <label className="form-label my-3">
                            {t("12th Certificate")}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="file"
                            name="twelveth_qualification"
                            accept=".pdf"
                            className="form-control"
                            onChange={handleChangeInput}
                          />
                          {staff.twelveth_qualification && (
                            <p className="text-primary">
                              Selected file: {staff.twelveth_qualification.name}
                            </p>
                          )}
                        </div>
                        <div className="col-md-6">
                          <label className="form-label my-3">
                            {t("Highest Qualification")}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="file"
                            name="highest_qualification"
                            accept=".pdf"
                            className="form-control"
                            onChange={handleChangeInput}
                          />
                          {staff.highest_qualification && (
                            <p className="text-primary">
                              Selected file: {staff.highest_qualification.name}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddStaff;
